const dataTableLanguageUrl = "/js/datatables/sv_SE.json";

export function initializeDelsitesTable() {
    const delsiteTable = $("#delsites-table-filtered").DataTable({
        language: {url: dataTableLanguageUrl},
        processing: true,
        serverSide: false,
        responsive: true,
        stateSave: true,
        stateSaveParams: saveDelsitesTableState,
        stateLoadParams: loadDelsitesTableState,
        scrollX: true,
        pageLength: 50,
        layout: {
            topStart: [
                'pageLength',
                {buttons: ['excel']}
            ],
        },
        initComplete: function () {
            const filterValue = this.api().state.loaded() ? this.api().state.loaded().filterValue : 'all';
            $(`.radio-wrapper`).removeClass('selected-radio');
            $(`#${filterValue}-wrapper`).addClass('selected-radio');
            $(`input[type=radio][name=member-filter][value=${filterValue}]`).prop('checked', true);
            applyMemberFilter(filterValue);
        }
    });

    // Attach change listener to radio filters
    $("input[type=radio][name=member-filter]").on("change", function () {
        const filterValue = $(this).val();
        applyMemberFilter(filterValue);
        delsiteTable.state.save();
    });

    let selectedRowIndex = 0;
    let anchorRowIndex = null;

    function getVisibleRows() {
        return delsiteTable.rows({page: 'current'}).nodes().toArray();
    }

    function highlightRow(index) {
        const rows = getVisibleRows();
        if (!rows.length) return;

        index = Math.max(0, Math.min(index, rows.length - 1));
        $(rows).removeClass('highlighted-row');
        $(rows[index]).addClass('highlighted-row');
        selectedRowIndex = index;
        rows[index].scrollIntoView({block: 'nearest'});
    }

    function toggleCheckbox(rowIndex) {
        const rows = getVisibleRows();
        const checkbox = $(rows[rowIndex]).find('input[type=checkbox]').first();
        if (checkbox.length) {
            checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
        }
    }

    function selectRange(from, to) {
        const rows = getVisibleRows();
        const [start, end] = [from, to].sort((a, b) => a - b);
        for (let i = start; i <= end; i++) {
            const checkbox = $(rows[i]).find('input[type=checkbox]').first();
            checkbox.prop('checked', true).trigger('change');
        }
    }

    $(document).on('keydown.delsiteNav', function (e) {
        const rows = getVisibleRows();
        if (!rows.length) return;

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();

            const newIndex = e.key === 'ArrowDown'
                ? Math.min(selectedRowIndex + 1, rows.length - 1)
                : Math.max(selectedRowIndex - 1, 0);

            if (e.shiftKey) {
                if (anchorRowIndex === null) anchorRowIndex = selectedRowIndex;
                selectRange(anchorRowIndex, newIndex);
            } else {
                anchorRowIndex = newIndex;
            }

            highlightRow(newIndex);
        }

        if (e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            toggleCheckbox(selectedRowIndex);
        }
    });
}


function saveDelsitesTableState(settings, data) {
    data.filterValue = $("input[type=radio][name=member-filter]:checked").val();
}

function loadDelsitesTableState(settings, data) {
    if (!data.filterValue) {
        data.filterValue = 'all';
    }
}

function applyMemberFilter(value) {
    const delsiteTable = $("#delsites-table-filtered").DataTable();
    const memberOfAssociationColumnIndex = 2;
    const isMemberKey = "Ja";
    const nonMemberKey = "-";

    switch (value) {
        case "all":
            delsiteTable.column(memberOfAssociationColumnIndex).search("").draw();
            break;
        case "member":
            delsiteTable.column(memberOfAssociationColumnIndex).search(isMemberKey).draw();
            break;
        case "non-member":
            delsiteTable.column(memberOfAssociationColumnIndex).search(nonMemberKey).draw();
            break;
    }
}

